import Vue from 'vue';
import CouponDiscountPopup from './couponDiscountPopup.vue';

interface PopupResult {
  success: boolean;
  action: string;
}

class CouponDiscountPopupService {
  private instance: Vue | null = null;

  private resolvePromise: ((value: PopupResult) => void) | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rejectPromise: ((reason?: any) => void) | null = null;

  /**
   * 显示弹窗
   * @returns Promise<PopupResult> 返回用户选择结果
   */
  public show(
  ): Promise<PopupResult> {
    return new Promise((resolve, reject) => {
      this.resolvePromise = resolve;
      this.rejectPromise = reject;

      // 创建弹窗实例
      if (!this.instance) {
        try {
          this.instance = new Vue({
            render: (h) => h(CouponDiscountPopup, {
              props: {
                modelValue: true,
              },
              on: {
                'update:modelValue': (value: boolean) => {
                  if (!value) {
                    this.hide();
                  }
                },
                confirm: () => {
                  resolve({ success: true, action: 'confirm' });
                },
                cancel: () => {
                  resolve({ success: false, action: 'cancel' });
                },
              },
            }),
          });

          // 挂载到DOM
          const mountedDom = document.createElement('div');
          document.body.appendChild(mountedDom);
          this.instance.$mount(mountedDom);
        } catch (error) {
          reject(new Error('弹窗创建失败'));
        }
      } else {
        // 更新参数并显示
        if (this.instance.$children && this.instance.$children.length) {
          this.instance.$children[0].$props.modelValue = true;
        }
      }
    });
  }

  /**
   * 隐藏弹窗
   */
  public hide(): void {
    if (this.instance) {
      if (this.instance.$children && this.instance.$children.length) {
        this.instance.$children[0].$props.modelValue = false;
      }
    }

    // 如果有未处理的Promise，reject它
    if (this.rejectPromise) {
      this.rejectPromise(new Error('弹窗被关闭'));
      this.rejectPromise = null;
    }
  }

  /**
   * 销毁弹窗实例
   */
  public destroy(): void {
    if (this.instance) {
      this.hide();
      this.instance = null;
    }
  }
}

// 创建单例
const couponDiscountPopupService = new CouponDiscountPopupService();

// 导出服务实例和便捷方法
export default couponDiscountPopupService;

// 便捷的show方法
export const showCouponDiscountPopup = (
): Promise<PopupResult> => couponDiscountPopupService.show();

// 便捷的hide方法
export const hideCouponDiscountPopup = (): void => {
  couponDiscountPopupService.hide();
};

// 便捷的destroy方法
export const destroyCouponDiscountPopup = (): void => {
  couponDiscountPopupService.destroy();
};
